import {
	Component,
	ElementRef,
	Input,
	ViewChild,
	OnChanges
} from '@angular/core';
import {
	THEME_COLOR_BLUE,
	THEME_COLOR_GREEN,
	THEME_COLOR_MAIN,
	THEME_COLOR_PINK,
	THEME_COLOR_VIOLET
} from 'src/app/core/services/constant/constants.service';
import { FacadeService } from 'src/app/core/services/facade.service';
import { DateUtils } from 'src/app/shared/utils/date-utils';

@Component({
	selector: 'app-working-time-dispersion',
	templateUrl: './working-time-dispersion.component.html',
	styleUrls: ['./working-time-dispersion.component.scss']
})
export class WorkingTimeDispersionComponent implements OnChanges {
	allstatistiques: any[] = [];
	@Input() categorie;
	colorArray = {
		'1': THEME_COLOR_BLUE,
		'2': THEME_COLOR_GREEN,
		'3': THEME_COLOR_PINK,
		'4': THEME_COLOR_VIOLET
	};

	options2;
	@Input() statistiquesTravail: any;
	@Input() statistiquesTrajet: any;
	@Input() statistiquesTotal: any;

	isSESSAD = false;
	isSAAD = false;
	isSSIAD = false;

	constructor(protected dateUtils: DateUtils, private facade: FacadeService) {
		this.isSESSAD = this.facade.dataStorageService.isSESSAD();
		this.isSAAD = this.facade.dataStorageService.isSAAD();
		this.isSSIAD = this.facade.dataStorageService.isSSIAD();
	}

	ngOnChanges() {
		this.allstatistiques = [];
		this.allstatistiques.push(
			this.hoursArrayTosecondsArray(this.statistiquesTravail)
		);
		this.allstatistiques.push(
			this.hoursArrayTosecondsArray(this.statistiquesTrajet)
		);
		this.allstatistiques.push(
			this.hoursArrayTosecondsArray(this.statistiquesTotal)
		);

		this.addDataConvertedFromMinutesToStringHourForTooltip();

		if (this.isSESSAD) {
			this.options2 = {
				tooltip: {
					trigger: 'axis',
					axisPointer: {
						type: 'shadow'
					},
					formatter(params) {
						const tooltip =
							'Q1: ' +
							params[0].data[8] +
							'<br>Q3: ' +
							params[0].data[9] +
							'<br>tempsMin: ' +
							params[0].data[10] +
							'<br> tempsMax: ' +
							params[0].data[11] +
							'';

						return tooltip;
					}
				},
				legend: {
					data: ['LPC', 'LSF', 'PDN', 'Oral'],
					align: 'left'
				},
				xAxis: {
					data: [
						{
							value: 'Temps de travail',
							textStyle: { fontSize: 20, color: THEME_COLOR_MAIN }
						},
						{
							value: 'Temps de trajet',
							textStyle: { fontSize: 20, color: THEME_COLOR_MAIN }
						},
						{
							value: 'Temps total',
							textStyle: { fontSize: 20, color: THEME_COLOR_MAIN }
						}
					],
					axisTick: {
						alignWithLabel: true
					}
				},
				yAxis: {
					name: 'Temps en heure',
					nameTextStyle: { fontSize: 20, color: THEME_COLOR_MAIN },
					nameLocation: 'middle',
					nameGap: 50,
					axisLabel: {
						formatter: (value) => {
							return this.dateUtils.timeConvert(value);
						},
						color: THEME_COLOR_MAIN
					}
				},
				series: [
					{
						type: 'k',
						data: this.allstatistiques,
						itemStyle: {
							color: this.colorArray[this.categorie],
							borderColor: this.colorArray[this.categorie]
						}
					}
				]
			};
		} else if (this.isSAAD) {
			this.options2 = {
				tooltip: {
					trigger: 'axis',
					axisPointer: {
						type: 'shadow'
					},
					formatter(params) {
						const tooltip =
							'Q1: ' +
							params[0].data[8] +
							'<br>Q3: ' +
							params[0].data[9] +
							'<br>tempsMin: ' +
							params[0].data[10] +
							'<br> tempsMax: ' +
							params[0].data[11] +
							'';

						return tooltip;
					}
				},
				legend: {
					data: ['Aide à domicile'],
					align: 'left'
				},
				xAxis: {
					data: [
						{
							value: 'Temps de travail',
							textStyle: { fontSize: 20, color: THEME_COLOR_MAIN }
						},
						{
							value: 'Temps de trajet',
							textStyle: { fontSize: 20, color: THEME_COLOR_MAIN }
						},
						{
							value: 'Temps total',
							textStyle: { fontSize: 20, color: THEME_COLOR_MAIN }
						}
					],
					axisTick: {
						alignWithLabel: true
					}
				},
				yAxis: {
					name: 'Temps en heure',
					nameTextStyle: { fontSize: 20, color: THEME_COLOR_MAIN },
					nameLocation: 'middle',
					nameGap: 50,
					axisLabel: {
						formatter: (value) => {
							return this.dateUtils.timeConvert(value);
						},
						color: THEME_COLOR_MAIN
					}
				},
				series: [
					{
						type: 'k',
						data: this.allstatistiques,
						itemStyle: {
							color: this.colorArray[this.categorie],
							borderColor: this.colorArray[this.categorie]
						}
					}
				]
			};
		}
	}

	strToSeconds(stime) {
		const tt = stime?.split(':').reverse();
		return (
			(tt?.length >= 3 ? +tt[2] : 0) * 60 * 60 +
			(tt?.length >= 2 ? +tt[1] : 0) * 60 +
			(tt?.length >= 1 ? +tt[0] : 0)
		);
	}

	hoursArrayTosecondsArray(array: any) {
		const arrayNew = array.map((arrayItem) => {
			return this.strToSeconds(arrayItem?.toString());
		});
		return arrayNew;
	}

	addDataConvertedFromMinutesToStringHourForTooltip() {
		this.allstatistiques.forEach((categorie) => {
			for (let i = 0; i < 4; i++) {
				categorie.push(this.dateUtils.timeConvert(categorie[i]));
			}
		});
	}
}
